import { __require as requireIteratorsCore } from './node_modules-core-js-internals-iterators-core.js';
import { __require as requireObjectCreate } from './node_modules-core-js-internals-object-create.js';
import { __require as requireCreatePropertyDescriptor } from './node_modules-core-js-internals-create-property-descriptor.js';
import { __require as requireSetToStringTag } from './node_modules-core-js-internals-set-to-string-tag.js';
import { __require as requireIterators } from './node_modules-core-js-internals-iterators.js';

var iteratorCreateConstructor;
var hasRequiredIteratorCreateConstructor;

function requireIteratorCreateConstructor () {
	if (hasRequiredIteratorCreateConstructor) return iteratorCreateConstructor;
	hasRequiredIteratorCreateConstructor = 1;
	var IteratorPrototype = requireIteratorsCore().IteratorPrototype;
	var create = requireObjectCreate();
	var createPropertyDescriptor = requireCreatePropertyDescriptor();
	var setToStringTag = requireSetToStringTag();
	var Iterators = requireIterators();

	var returnThis = function () { return this; };

	iteratorCreateConstructor = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
	  var TO_STRING_TAG = NAME + ' Iterator';
	  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
	  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
	  Iterators[TO_STRING_TAG] = returnThis;
	  return IteratorConstructor;
	};
	return iteratorCreateConstructor;
}

export { requireIteratorCreateConstructor as __require };
//# sourceMappingURL=node_modules-core-js-internals-iterator-create-constructor.js.map
